
import Vue, { PropType } from 'vue'
import DropdownMenu from '@innologica/vue-dropdown-menu'

export type DataType = {
  showFilter: boolean;
}

export type OptionItem = {
  label: string;
  value: string;
  classes?: Array<string>;
}

export default Vue.extend({
  name: 'GatewayListHeader',

  components: {
    DropdownMenu
  },

  props: {
    left: String as PropType<string>,
    value: String as PropType<string>,
    label: String as PropType<string>,
    options: Array as PropType<OptionItem[]>
  },

  data(): DataType {
    return {
      showFilter: false,
    }
  },

  computed: {
    selecting(): boolean {
      return this.value !== undefined
    },

    widthStyleText(): string {
      if (this.left) {
        // this.left = ヘッダテキストの長さ
        // ヘッダテキストの長さ + 下矢印アイコン横幅 - レギュレーションのマージン幅
        return `min-width: ${Number(this.left) + 36 - 16}px;`
      }
      return ''
    }
  },

  methods: {
    select(op: OptionItem): void {
      this.$emit('input', op.value)
      this.showFilter = false
    },

    clearFilter(): void {
      this.$emit('input', undefined)
      this.showFilter = false
    },

    isSelected(op: OptionItem): boolean {
      return this.value === op.value
    },

    classesText(op: OptionItem): string {
      return (this.isSelected(op) ? ['key'] : (op.classes || [])).join(' ')
    }
  }
})
